import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: apiUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Otomatik Interceptor: Her istek atıldığında localStorage'dan token'ı okur ve ekler
apiClient.interceptors.request.use(
  (config) => {
    // LocalStorage'a kaydettiğiniz key anahtarının tam adını yazın (örn: 'token', 'userToken', 'jwt')
    const token = localStorage.getItem('token'); 

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;